import Typography from "@mui/material/Typography";

export default function DataNotFound({ text }) {
  return <Typography component="p">{text}</Typography>;
}
